import { Component, OnInit, AfterViewInit } from '@angular/core';
import { faq } from './faq';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit, AfterViewInit {
  faq: any;
  // actives: boolean [];
  active: string;
  id: string;

  constructor(
    private route: ActivatedRoute,
  ) {
    this.route.fragment.subscribe((fragment: string) => {
      this.active = fragment;
    });
    }

  ngOnInit() {
    this.faq = faq;
    // this.actives = [];
  }

  ngAfterViewInit() {
    // if (this.id) {
    //   document.getElementById(this.id).scrollIntoView(true);
    // }
  }

  toggleActive(id) {
    if (this.active === id) {
      this.active = null;
    } else {
      this.active = id;
    }
    // if (this.actives[index] !== undefined) {
    //     this.actives[index] = !this.actives[index];
    // } else {
    //     this.actives[index] = false;
    // }
  }

  checkActive(id) {
    if (this.active === id) {
      return true;
    } else {
      return false;
    }
    // if (this.actives[index] === undefined) this.actives[index] = false;

    // return this.actives[index]
  }

}
